import { BREAKPOINTS } from '../constants/breakpoints';
import { useBreakpoint as useExternalBreakpoint } from 'use-breakpoint';

export function useBreakpoint() {
  const currentBreakpoint = useExternalBreakpoint(BREAKPOINTS);

  const isMobile = currentBreakpoint.breakpoint === 'mobile';
  const isTablet = currentBreakpoint.breakpoint === 'tablet';
  const isDesktop = currentBreakpoint.breakpoint === 'desktop';

  return {
    breakpoint: currentBreakpoint,
    isMobile,
    isTablet,
    isDesktop,
  };
}
